/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-29 10:33:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Stack, Thumbnail } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = WithI18nProps & {
  limitShow?: number,
  thumbnails: string[]
};

class GroupProduct extends Component<Props> {
  render() {
    const { i18n, limitShow, thumbnails } = this.props;
    let listImgs = thumbnails;
    if (limitShow > 0 && thumbnails.length > limitShow) {
      listImgs = thumbnails.slice(0, limitShow);
    }
    const restNumberItem = thumbnails.length - listImgs.length
    return (
      <div className="BC-Page__ManualType__RecommendationProduct">
        <Stack alignment="center" spacing="extraTight">
          {!!listImgs.length &&
            listImgs.map((img, index) => <Thumbnail source={img} size="small" key={index} />)}

          {listImgs.length < thumbnails.length && (
            <span className="BC-Page__ManualType__RecommendationProduct__items">
              +{thumbnails.length - listImgs.length}{' '}
              {i18n.translate('AdminHTML.Recommendation.ManualRecommendation.Common.items_t', {
                count: restNumberItem < 1 ? 1 : restNumberItem
              })}
            </span>
          )}
        </Stack>
      </div>
    );
  }
}

GroupProduct.defaultProps = {
  limitShow: 0
};

export default withI18n()(GroupProduct);
